import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { baseURL } from "services/api";
import { ReferralResponse } from "./types";

const baseQuery = fetchBaseQuery({
  baseUrl: `${baseURL}/referral`,
  prepareHeaders: (headers) => {
    headers.set("Accept", "application/json");
    headers.set("Content-Type", "application/json");
    return headers;
  },
});

export const referralApi = createApi({
  reducerPath: "referralService",
  baseQuery,
  endpoints: (builder) => ({
    createReferral: builder.mutation<ReferralResponse, CreateReferralDto>({
      query: (payload: CreateReferralDto) => ({
        url: `/`,
        method: "POST",
        body: payload,
      }),
    }),
    getMyBookings: builder.query({
      query: (userId: number) => `/v2/booking/${userId}`,
    }),
    getReferralById: builder.query<any, number>({
      query: (id) => `/${id}`,
    }),
  }),
});
export const {
  useCreateReferralMutation,
  useGetMyBookingsQuery,
  useLazyGetMyBookingsQuery,
  useLazyGetReferralByIdQuery,
} = referralApi;

export interface CreateReferralDto {
  user_id: number;
  business_id: number;
  item_id?: number;
  availability_id?: number;
  referral_type: number;
  state: number;
  customer_name?: string;
  customer_phone?: string;
  channel?: string;
  external_availability_id?: number;
  customer_email?: string;
  fareharbor_customer_prototype_id?: number;
}
